import { render, staticRenderFns } from "./BusReport.vue?vue&type=template&id=23336752&scoped=true&"
import script from "./BusReport.vue?vue&type=script&lang=js&"
export * from "./BusReport.vue?vue&type=script&lang=js&"
import style0 from "./BusReport.vue?vue&type=style&index=0&id=23336752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23336752",
  null
  
)

export default component.exports